// Vendor scripts
import 'bootstrap'

// Vue
import './vue/vue'

// Custom scripts
import './scripts/accordion-search'
import './scripts/bootstrap-carousel'
import './scripts/alert'
import './scripts/anchor'
import './scripts/collapse-prevent-close'
import './scripts/component-modals'
import './scripts/cludo-search-box'
import './scripts/form-validation'
import './scripts/googleMap'
import './scripts/header'
import './scripts/image-caption-toggle'
import './scripts/image-modal'
import './scripts/listing-component'
import './scripts/social-share-content-block'
import './scripts/swiper-config'
import './scripts/symptom-checker'
import './scripts/video-modal'

// Export libraries for global use
import * as d3 from 'd3'
window.d3 = d3

import ScrollMagic from 'scrollmagic'
window.ScrollMagic = ScrollMagic